export default class FollowUpCost {
    constructor(config, startAge, cost, chargeLevel) {
        this.id = null;
        this.config = config;
        this.startAge = startAge;
        this.cost = cost;
        this.chargeLevel = chargeLevel;
        this.deleted = false;
    }

    static fromData(config, data) {
        const followUpCost = new FollowUpCost(config, data.startAge, data.cost, data.chargeLevel);
        followUpCost.id = data.id;
        return followUpCost;
    }

    serialize() {
        return {
            id: this.id,
            startAge: Number.parseInt(this.startAge),
            cost: this.cost.id,
            chargeLevel: this.chargeLevel,
            deleted: this.deleted,
        };
    }
}
